import Breakpoints from "./breakpoints";

export const fontSizing = {
  [Breakpoints.desktop4]: {
    xs: "10px",
    s: "12px",
    m: "14px",
    l: "16px",
    xl: "18px",
    "h-s": "20px",
    "h-m": "24px",
    "h-l": "32px",
    "h-xl": "48px",
  },
  [Breakpoints.tablet]: {
    xs: "9px",
    s: "11px",
    m: "13px",
    l: "15px",
    xl: "16px",
    "h-s": "18px",
    "h-m": "22px",
    "h-l": "28px",
    "h-xl": "48px",
  },
  [Breakpoints.mobile3]: {
    xs: "8px",
    s: "10px",
    m: "12px",
    l: "14px",
    xl: "14px",
    "h-s": "16px",
    "h-m": "20px",
    "h-l": "24px",
    "h-xl": "36px",
  },
};

export const lineHeightSizing = {
  [Breakpoints.desktop4]: {
    xs: "16px",
    s: "20px",
    m: "24px",
    l: "28px",
    xl: "32px",
    "h-s": "36px",
    "h-m": "40px",
    "h-l": "44px",
    "h-xl": "64px",
  },
  [Breakpoints.tablet]: {
    xs: "14px",
    s: "18px",
    m: "22px",
    l: "26px",
    xl: "30px",
    "h-s": "34px",
    "h-m": "38px",
    "h-l": "42px",
    "h-xl": "64px",
  },
  [Breakpoints.mobile3]: {
    xs: "12px",
    s: "16px",
    m: "20px",
    l: "24px",
    xl: "28px",
    "h-s": "32px",
    "h-m": "36px",
    "h-l": "40px",
    "h-xl": "44px",
  },
};
